export interface FormatOptions extends Intl.NumberFormatOptions {
  locales?: string | string[]
}

export const formatNumber = (
  value: number | string,
  { locales = "vi", ...options }: FormatOptions = {}
) => {
  return new Intl.NumberFormat(locales, options).format(
    typeof value === "number" ? value : Number(value)
  )
}
